export const RESET_API_ERROR_STATE = "api/RESET_ERROR";


export const resetApiErrorState = (actionPrefixes) => ({
    type: RESET_API_ERROR_STATE,
    actionPrefixes
});